module.exports = __webpack_public_path__ + "img/rectangle.9f18790b.svg";